export default "__VITE_ASSET__ec9398e8__"